/**
 * Arabic for build 7: no sample figure passes for a real one on the live
 * platform, and the last old boards' entries are saved there — the shell's
 * notices, the screens' "sample data" lines, and the board text i18n/dom.ts
 * translates inside the boards. Proposed; pending native aviation review.
 */
const ar: Record<string, string> = {
  /* the shell's part-sample line on every board */
  "{wo} work orders, {ins} inspections and {docs} documents here are from the platform. {n} of the work orders have no position, so they are listed but not drawn. The survey, surface reports, the facilities and carousel registers, projects and live feeds are sample data, not real.":
    "{wo} أمر عمل و{ins} تفتيش و{docs} وثيقة هنا من المنصة. {n} من أوامر العمل بلا موقع، لذلك تُعرض في القائمة ولا تُرسم. المسح وبلاغات حالة السطح وسجلّا المرافق والسيور الدوّارة والمشاريع والمصادر الحية بيانات تجريبية وليست حقيقية.",
  "{wo} work orders, {ins} inspections and {docs} documents here are from the platform. The survey, surface reports, the facilities and carousel registers, projects and live feeds are sample data, not real.":
    "{wo} أمر عمل و{ins} تفتيش و{docs} وثيقة هنا من المنصة. المسح وبلاغات حالة السطح وسجلّا المرافق والسيور الدوّارة والمشاريع والمصادر الحية بيانات تجريبية وليست حقيقية.",

  /* what the shell says when a board's entry is saved */
  "The platform has no test type for assessments yet. Ask an administrator to add it.":
    "لا يوجد على المنصة نوع اختبار للتقييمات بعد. اطلب من المسؤول إضافته.",
  "{ref} saved on the platform as a test record.": "حُفظ {ref} على المنصة سجلَّ اختبار.",
  "{ref} corrected on the platform (revision {n}).": "صُحّح {ref} على المنصة (المراجعة {n}).",
  "Nothing to save: the check names no system.": "لا شيء للحفظ: الفحص لا يحدد نظامًا.",
  "Daily check {ref} saved on the platform.": "حُفظ الفحص اليومي {ref} على المنصة.",
  "Breakdown recorded on the platform as {ref}.": "سُجّل العطل على المنصة برقم {ref}.",
  "Alarm acknowledgement saved on the platform.": "حُفظ الإقرار بالإنذار على المنصة.",

  "No passenger count yet.": "لا يوجد عدد للمسافرين بعد.",
  "Nothing has been entered in the store yet.": "لم يُدخل شيء في المخزن بعد.",
  "Per-passenger figures stay blank until the yearly passengers are entered below.":
    "تبقى الأرقام لكل مسافر فارغة إلى أن يُدخل عدد المسافرين السنوي أدناه.",

  /* board text (i18n/dom.ts): Executive KPIs, the Overview headline, Sustainability, Assessments */
  "No data yet, so not graded.": "لا بيانات بعد، لذا لم يُقيَّم.",
  "NO PROBLEMS IN WHAT IS FED": "لا مشكلات فيما يصل من بيانات",
  "NOT ENOUGH DATA YET": "البيانات غير كافية بعد",
  "indicators have no data yet": "مؤشرات بلا بيانات بعد",
  "No indicator on this board has data yet. Connect the feeds to see the airport's status.":
    "لا يوجد مؤشر على هذه اللوحة له بيانات بعد. اربط المصادر لترى حالة المطار.",
  "Everything with data is inside its limits. Indicators with no data are not counted.":
    "كل ما له بيانات ضمن حدوده. المؤشرات التي بلا بيانات لا تُحتسب.",
  "no data on the platform yet": "لا بيانات على المنصة بعد",
  "No sustainability data on the platform yet.": "لا توجد بيانات استدامة على المنصة بعد.",
  "Emissions, energy, waste and noise need a feed from the environment office.":
    "تحتاج الانبعاثات والطاقة والنفايات والضوضاء إلى مصدر بيانات من إدارة البيئة.",
  "The Green program screen uses the airport's own meters.": "شاشة البرنامج الأخضر تعتمد على عدادات المطار نفسه.",
  "Reading the test records…": "جارٍ قراءة سجلات الاختبار…",
  "Demonstration test records are not shown here. They are on Testing records.":
    "لا تُعرض هنا سجلات الاختبار التوضيحية. تجدها في سجلات الاختبار.",
  "No assessments on the record yet. Add the first with ADD A RECORD.":
    "لا توجد تقييمات في السجل بعد. أضف الأول بزر «ADD A RECORD».",
};
export default ar;
